import {getSessionStorageItem} from '../../sessionStorage';
import SESSION_SAUCE_EMPLOYEE_NAME from '../../sessionStorage/constants';

export const FEATURE_RESTRICTION_IDS = {
  ORDERS: 'orders',
  ORDERS_V2: 'orders_v2',
  SHOW_BYOC_EVENTS: 'show_byoc_events',
  BOOK_A_DRIVER: 'book_a_driver',
  BOOK_A_DRIVER_V2: 'book_a_driver_v2',
  BAD_ORDERS_TOOLTIP: 'bad_orders_tooltip',
  LARGE_DELIVERY: 'large_delivery',
  MENU_EDITOR: 'menu_editor',
  STORE_SETTINGS: 'store_settings',
  ANALYTICS: 'analytics',
  DISCOUNTS: 'discounts',
  REPORTS: 'reports',
  VIRTUAL_NUMBERS: 'virtual_number',
  FEEDBACK: 'feedback',
  MY_ACCOUNT: 'my_account',
  TEAM: 'team',
  HELP: 'help',
  HYBRID_DELIVERY: 'stream_events_byoc_vs_self_hybrid_delivery',
  REFUNDS: 'refunds',
  SALES_REPORTS: 'sales_reports',
  SALES_REPORTS_BULK_EXPORT: 'sales_reports_bulk_export',
  CUSTOMERS_REPORTS: 'customers_reports',
  REFUNDS_REPORTS: 'refunds_reports',
  EMAIL_MARKETING: 'marketing',
  EMAIL_MARKETING_DASHBOARD_V2: 'email_marketing_dashboard_v2',
  SHOW_MARKETING_RESULT: 'show_marketing_results',
  FLYERS: 'flyers',
  INSIGHTS_GROWTH: 'insights_growth',
  INSIGHTS_PERFORMANCE: 'insights_performance',
  PAYMENT_ADJUSTMENT: 'payment_adjustment',
  MARKETING_INTEGRATIONS: 'marketing_integrations',
  DISCOUNTS_V2: 'discounts_v2',
  SPECIAL_ORDERS_REPORT: 'special_orders_report',
  DISCOUNTS_NEW_DESIGN: 'discounts_new_design',
  MAIN_PAGE: 'main_page',
  MARKETING_EMAIL_CUSTOMIZATION: 'marketing_email_customization',
  BYOC_ONBOARDING: 'byoc_onboarding',
  MENU_PRICE_ADJUST: 'menu_price_adjust',
  MULTI_MODIFIERS: 'multi_modifiers',
  SELF_DELIVERY_REPORT: 'self_delivery_report',
  BLOCK_SELF_DELIVERY_REPORT: 'block_self_delivery_report',
  SELF_DELIVERY_INVOICES_REPORT: 'self_delivery_invoices_report',
  HOLIDAY_HOURS_V2: 'holiday_hours_v2',
  BYOC: 'byoc',
  SALES_BREAKDOWN_REPORT: 'sales_breakdown_report',
  STOREFRONT_CASHBACK: 'storefront_cashback',
  CASHBACK: 'cashback',
  BOOK_A_DRIVER_AUTO_CHARGE: 'book_a_driver_auto_charge',
  PICKUP_READY_REQUIRED: 'pickup_ready_required',
  CUSTOMER_INSIGHTS: 'customer_insights',
  INVITE_A_BITE: 'invite_a_bite',
  PAUSE_ORDER_CHANNELS_SELECTION: 'pause_order_channels_selection',
  OTTER_SHOW_BRAND_NAME: 'otter_show_brand_name',
  SHOW_BYOC_TIP: 'show_byoc_tip',
  DASHBOARD_SELF_DELIVERY_REPORT_SPLIT_FEE_TIP:
    'dashboard_self_delivery_report_split_fee_tip',
  BYOC_BANK_ACCOUNT_UPDATE: 'byoc_bank_account_update',
  SHOW_PROOF_OF_DELIVERY: 'show_proof_of_delivery',
  STREAM_EVENTS_READY_BUTTON_MARKETPLACE_DELIVERY:
    'stream_events_ready_button_marketplace_delivery'
};

export const FEATURE_RESTRICTION_PATHS = {
  [FEATURE_RESTRICTION_IDS.ORDERS]: '/orders',
  [FEATURE_RESTRICTION_IDS.ORDERS_V2]: '/orders-v2',
  [FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER]: '/book-a-driver',
  [FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2]: '/book-a-driver',
  [FEATURE_RESTRICTION_IDS.MENU_EDITOR]: '/menu-editor',
  [FEATURE_RESTRICTION_IDS.STORE_SETTINGS]: '/store-settings',
  [FEATURE_RESTRICTION_IDS.ANALYTICS]: '/analytics',
  [FEATURE_RESTRICTION_IDS.DISCOUNTS]: '/discounts',
  [FEATURE_RESTRICTION_IDS.REPORTS]: '/reports',
  [FEATURE_RESTRICTION_IDS.VIRTUAL_NUMBERS]: '/virtual-number',
  [FEATURE_RESTRICTION_IDS.FEEDBACK]: '/feedback',
  [FEATURE_RESTRICTION_IDS.TEAM]: '/team',
  [FEATURE_RESTRICTION_IDS.EMAIL_MARKETING]: '/marketing',
  [FEATURE_RESTRICTION_IDS.FLYERS]: '/flyers',
  [FEATURE_RESTRICTION_IDS.MY_ACCOUNT]: '/my-account',
  [FEATURE_RESTRICTION_IDS.INSIGHTS_GROWTH]: '/insights/growth',
  [FEATURE_RESTRICTION_IDS.INSIGHTS_PERFORMANCE]: '/insights/performance',
  [FEATURE_RESTRICTION_IDS.DISCOUNTS_V2]: '/discounts-v2',
  [FEATURE_RESTRICTION_IDS.EMAIL_MARKETING_DASHBOARD_V2]: '/marketing-v2',
  [FEATURE_RESTRICTION_IDS.MAIN_PAGE]: '/main-page',
  [FEATURE_RESTRICTION_IDS.BYOC_ONBOARDING]: '/byoc-onboarding',
  [FEATURE_RESTRICTION_IDS.CASHBACK]: '/cashback'
};

export const STRIPE_ACCOUNT_RESTRICTION_NAMES = {
  CONNECTED_STANDARD: 'Connected_Standard',
  CONNECTED_EXPRESS: 'Express'
};

export const stripeAccRestrictedFeatures = ['sales_reports', 'refunds_reports'];

export const getInsightsRestriction = (serviceFeatures) => {
  let result;
  if (serviceFeatures.includes(FEATURE_RESTRICTION_IDS.INSIGHTS_GROWTH)) {
    result = FEATURE_RESTRICTION_IDS.INSIGHTS_GROWTH;
  } else {
    result = FEATURE_RESTRICTION_IDS.INSIGHTS_PERFORMANCE;
  }
  return result;
};

export const getBookADriverRestriction = (serviceFeatures) => {
  let result;
  if (serviceFeatures.includes(FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2)) {
    result = FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2;
  } else {
    result = FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER;
  }

  return result;
};

export const getOrderV2Restriction = (serviceFeatures) => {
  let result;
  if (serviceFeatures.includes(FEATURE_RESTRICTION_IDS.SHOW_BYOC_EVENTS)) {
    result = FEATURE_RESTRICTION_IDS.SHOW_BYOC_EVENTS;
  } else {
    result = FEATURE_RESTRICTION_IDS.ORDERS_V2;
  }

  return result;
};

export const getOrdersV2Restriction = (serviceFeatures) => {
  let result;
  if (serviceFeatures.includes(FEATURE_RESTRICTION_IDS.ORDERS_V2)) {
    result = FEATURE_RESTRICTION_IDS.ORDERS_V2;
  } else {
    result = FEATURE_RESTRICTION_IDS.ORDERS;
  }

  return result;
};

export const PATHS_WITH_REDIRECT = [
  '/orders',
  '/orders-v2',
  '/book-a-driver',
  '/discounts',
  '/discounts-v2',
  '/insights'
];

export const checkIfSauceEmployee = () => {
  try {
    if (typeof sessionStorage === 'undefined') {
      return false;
    }
    const item = sessionStorage.getItem(SESSION_SAUCE_EMPLOYEE_NAME);
    if (item === null || item === undefined) {
      return false;
    }
    const value = JSON.parse(item);
    return !!value;
  } catch (error) {
    return false;
  }
};

export const hasBookADriverAccess = (serviceFeatures) => {
  const isSauceEmployee = checkIfSauceEmployee();
  if (isSauceEmployee) {
    return true;
  }
  const hasV1 = serviceFeatures.includes(FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER);
  const hasV2 = serviceFeatures.includes(
    FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2
  );
  return hasV1 || hasV2;
};

export const hasLargeDeliveryAccess = (
  serviceFeatures = [],
  location = null
) => {
  const isCatering = location?.IsCatering;
  return (
    !isCatering &&
    (serviceFeatures.includes(FEATURE_RESTRICTION_IDS.ORDERS_V2) ||
      serviceFeatures.includes(FEATURE_RESTRICTION_IDS.SHOW_BYOC_EVENTS)) &&
    serviceFeatures.includes(FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2) &&
    serviceFeatures.includes(FEATURE_RESTRICTION_IDS.LARGE_DELIVERY)
  );
};

export const getBookADriverVersion = (serviceFeatures) => {
  const isSauceEmployee = checkIfSauceEmployee();
  const hasV1 = serviceFeatures.includes(FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER);
  const hasV2 = serviceFeatures.includes(
    FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2
  );

  if (isSauceEmployee) {
    // Sauce employees: use v1 if location has v1 flag, otherwise v2
    return hasV1 ? 'v1' : 'v2';
  }

  // Regular users: use v1 if location has v1 flag, v2 if location has v2 flag
  if (hasV1) {
    return 'v1';
  }
  if (hasV2) {
    return 'v2';
  }
  return null;
};
